import { LatestCollectionCarouselModel } from "./CollectionModel";

export class LatestCollectionsCMSCarouselInfo {
  collections: LatestCollectionCarouselModel[];
  isLoading: boolean = false;
  isCompleted: boolean = false;
  language: string = undefined;
}